import type { ReportHistoryTriggerUnionType } from '@api';
import { Badge } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { getReportHistoryTriggerColor } from './helpers';

type ReportHistoryTriggerBadgePropsType = {
  trigger: ReportHistoryTriggerUnionType;
};

export const ReportHistoryTriggerBadge: React.FC<
  ReportHistoryTriggerBadgePropsType
> = ({ trigger }) => {
  const { t } = useTranslation();
  const { backgroundColor, textColor } = getReportHistoryTriggerColor(trigger);

  return (
    <Badge color={backgroundColor} style={{ color: textColor }}>
      {t(`REPORTS.ENUMS.TRIGGER.${trigger}`)}
    </Badge>
  );
};
